import {
  FLOW_EDITOR_FEATURE_FLAGS,
  isFlowEditorStepDeletable,
} from 'src/constants/flowEditorFeatureFlags'
import type { OnboardingTemplate, OnboardingTemplateStep } from 'src/interfaces/onboardingTemplate'
import { normalizeCollectDataTemplateConfigId, resolveStepGroupConfigId } from './configIds'

export interface FlowEditorStepDropTarget {
  configId: string
  indexInGroup: number
}

function normalizeConfigId(configId: string): string {
  return normalizeCollectDataTemplateConfigId(configId) || configId
}

export function isFlowEditorStepMovable(step: OnboardingTemplateStep): boolean {
  if (!FLOW_EDITOR_FEATURE_FLAGS.allowReorderSteps) {
    return false
  }

  return isFlowEditorStepDeletable(step)
}

export function resolveDraggedStepConfigId(
  draggedStepId: string,
  editorSteps: OnboardingTemplateStep[],
  template: OnboardingTemplate,
): string | null {
  const draggedStep = editorSteps.find((step) => {
    return step.id === draggedStepId
  })

  if (!draggedStep) {
    return null
  }

  return normalizeConfigId(resolveStepGroupConfigId(draggedStep, template))
}

export function isDropTargetInDraggedStepGroup(
  draggedStepConfigId: string | null,
  dropTarget: FlowEditorStepDropTarget,
): boolean {
  if (draggedStepConfigId === null) {
    return false
  }

  return normalizeConfigId(draggedStepConfigId) === normalizeConfigId(dropTarget.configId)
}

/** Final index within a group's steps (moved step excluded) for a drop target. */
export function computeInsertIndexInGroup(
  sourceIndexInGroup: number,
  targetIndexInGroup: number,
): number {
  if (sourceIndexInGroup < targetIndexInGroup) {
    return targetIndexInGroup - 1
  }

  return targetIndexInGroup
}

export function dropTargetsEqual(
  left: FlowEditorStepDropTarget | null,
  right: FlowEditorStepDropTarget | null,
): boolean {
  if (left === null || right === null) {
    return left === right
  }

  return left.configId === right.configId && left.indexInGroup === right.indexInGroup
}
